import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { PageTransition } from "@/components/PageTransition";
import { SmoothScroll } from "@/components/SmoothScroll";
import { CookieNotice } from "@/components/CookieNotice";
import Home from "@/pages/Home";

/* Only the homepage ships in the first bundle; every other page loads on demand. */
const WhyChooseUs = lazy(() => import("@/pages/WhyChooseUs"));
const Services = lazy(() => import("@/pages/Services"));
const Pricing = lazy(() => import("@/pages/Pricing"));
const Testimonials = lazy(() => import("@/pages/Testimonials"));
const Faqs = lazy(() => import("@/pages/Faqs"));
const Contact = lazy(() => import("@/pages/Contact"));
const Terms = lazy(() => import("@/pages/Terms"));
const Blog = lazy(() => import("@/pages/Blog"));
const Toaster = lazy(() => import("@/components/ui/sonner").then((m) => ({ default: m.Toaster })));

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-[60vh]" aria-hidden="true" />}>
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Navigate to="/" replace />} />
          <Route path="/team" element={<Navigate to="/" replace />} />
          <Route path="/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/privacy" element={<Navigate to="/terms#privacy" replace />} />
        </Routes>
      </Suspense>
    </PageTransition>
  );
};

function App() {
  return (
    <div className="App bg-slate-50 min-h-screen flex flex-col">
      <BrowserRouter>
        <SmoothScroll>
          <Navbar />
          <main className="flex-1">
            <AnimatedRoutes />
          </main>
          <Footer />
          <CookieNotice />
        </SmoothScroll>
      </BrowserRouter>
      <Suspense fallback={null}>
        <Toaster position="top-center" richColors />
      </Suspense>
    </div>
  );
}

export default App;
